var map = {
	"./avatar_jump_version1.mp3": 8038,
	"./avatar_jump_version2.mp3": 3801,
	"./avatar_jump_version3.mp3": 8852,
	"./avatar_run_loop.mp3": 3808,
	"./avatar_switch_side_version1.mp3": 4492,
	"./avatar_switch_side_version2.mp3": 9283,
	"./avatar_switch_side_version3.mp3": 7342,
	"./avatar_walk_loop.mp3": 4876,
	"./backboard_hit.mp3": 3355,
	"./ball_hit_version1.mp3": 1771,
	"./ball_hit_version2.mp3": 1044,
	"./ball_hit_version3.mp3": 5993,
	"./ball_roll.mp3": 7937,
	"./basketball_net_out_version1.mp3": 6748,
	"./basketball_net_out_version2.mp3": 1539,
	"./basketball_net_out_version3.mp3": 9598,
	"./beach_amb.mp3": 550,
	"./boat_tilt_version1.mp3": 1260,
	"./boat_tilt_version2.mp3": 6243,
	"./boat_tilt_version3.mp3": 5742,
	"./buzzer.mp3": 2548,
	"./buzzer_count.mp3": 8024,
	"./floor_hit_version1.mp3": 8412,
	"./floor_hit_version2.mp3": 8579,
	"./floor_hit_version3.mp3": 3838,
	"./floor_hit_version4.mp3": 3093,
	"./glow.mp3": 2945,
	"./net_shake_version1.mp3": 5070,
	"./net_shake_version2.mp3": 7057,
	"./net_shake_version3.mp3": 9196,
	"./net_version1.mp3": 319,
	"./net_version2.mp3": 9176,
	"./net_version3.mp3": 253,
	"./net_version4.mp3": 2630,
	"./net_version5.mp3": 2011,
	"./net_version6.mp3": 7572,
	"./rim_hit_version1.mp3": 2190,
	"./rim_hit_version2.mp3": 657,
	"./score.mp3": 8072,
	"./slow_motion.mp3": 1890,
	"./splash.mp3": 4839,
	"./transition_lose.mp3": 693,
	"./transition_tie.mp3": 3956,
	"./whistle.mp3": 3016,
	"./win.mp3": 8780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 644;